import { render, staticRenderFns } from "./FeedRuleForm.vue?vue&type=template&id=fa4dd83a&"
import script from "./FeedRuleForm.vue?vue&type=script&lang=js&"
export * from "./FeedRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports